module.exports = __webpack_public_path__ + "img/23.da91aa48.png";